import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Badge, Alert, Table, Accordion, Spinner, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import InfiniteScroll from 'react-infinite-scroll-component';
import useToken from 'hooks/useToken';
import PropTypes from 'prop-types';
import ErrorBoundary from 'components/common/ErrorBoundary';
import ModalSeguroCancelarSuscripcion from './Modales/ModalSeguroCancelarSuscripcion';
// Modal de recuperar eliminado temporalmente: no se permite recuperar suscripciones canceladas
import ModalConfirmarPagoManual from './Modales/ModalConfirmarPagoManual';
import ModalAgregarProductoSuscripcion from './Modales/ModalAgregarProductoSuscripcion';
import { useToast } from 'context/providers/ToastProvider';

const SeccionSuscripciones = ({
    idCliente,
    refreshKey,
    onPagoManualRegistrado
}) => {
    const { token, setToken, idCatTipoUsuario } = useToken();
    const { showErrorToast, showSuccessToast } = useToast();

    const [suscripciones, setSuscripciones] = useState([]);
    const [cargando, setCargando] = useState(true);
    const [ordenesSuscripcion, setOrdenesSuscripcion] = useState({});
    const [paginaOrdenes, setPaginaOrdenes] = useState({});
    const [hasMoreOrdenes, setHasMoreOrdenes] = useState({});
    const [totalOrdenes, setTotalOrdenes] = useState({});
    const [linkCopiado, setLinkCopiado] = useState({});
    const [stripeIdCopiado, setStripeIdCopiado] = useState({});
    const [cancelandoId, setCancelandoId] = useState(null);

    // Estados para editar Stripe Subscription ID inline (solo admin, solo sin ID)
    const [nuevoStripeId, setNuevoStripeId] = useState({});
    const [guardandoStripeId, setGuardandoStripeId] = useState({});
    const [editandoStripeId, setEditandoStripeId] = useState({});
    const [showModalCancelar, setShowModalCancelar] = useState(false);
    const [suscripcionACancelar, setSuscripcionACancelar] = useState(null);
    // Estados para recuperar suscripción eliminados temporalmente
    const [productosOrdenPrincipal, setProductosOrdenPrincipal] = useState({});
    const [cargandoProductos, setCargandoProductos] = useState({});
    const [licenciasServidor, setLicenciasServidor] = useState({});
    const [urlBasePagos, setUrlBasePagos] = useState('http://localhost:5173/?'); // URL por defecto
    
    // Estados para pago manual
    const [showModalPagoManual, setShowModalPagoManual] = useState(false);
    const [suscripcionAPagar, setSuscripcionAPagar] = useState(null);
    const [procesandoPago, setProcesandoPago] = useState(false);
    const [estadoPagoSuscripcion, setEstadoPagoSuscripcion] = useState({
        dSaldoRestante: 0,
        dSumaPagos: 0,
        bTodasOrdensPagadas: false
    });

    // Estados para agregar producto a suscripción
    const [showModalAgregarProducto, setShowModalAgregarProducto] = useState(false);
    const [suscripcionParaAgregarProducto, setSuscripcionParaAgregarProducto] = useState(null);

    // Estados para cambiar plan de suscripción

    /**
     * Formatea una fecha al formato [DD Mes YYYY]
     * Ejemplo: [15 Ene 2026]
     */
    const formatearFecha = (fecha) => {
        const meses = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
        const date = new Date(fecha);
        const dia = date.getDate();
        const mes = meses[date.getMonth()];
        const anio = date.getFullYear();
        return `${dia} ${mes} ${anio}`;
    };

    /**
     * Obtiene la URL base para los links de pago desde el backend
     */
    const obtenerUrlBasePagos = async () => {
        try {
            const response = await fetch('/api/Suscripciones/ObtenerUrlBasePagos', {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) {
                throw new Error('Error al obtener URL base de pagos');
            }

            const data = await response.json();
            if (data.iResponseType === 1 && data.detalles?.urlBase) {
                setUrlBasePagos(data.detalles.urlBase);
            }
        } catch (error) {
            console.error('Error obteniendo URL base de pagos:', error);
            // Se mantiene la URL por defecto del estado inicial
        }
    };

    /**
     * Obtiene las suscripciones del cliente
     */
    const obtenerSuscripcionesCliente = async () => {
        setCargando(true);

        try {

            const response = await fetch(`/api/Suscripciones/ObtenerSuscripciones?idCliente=${idCliente}`, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {

                const data = await response.json();

                if (data.iResponseType === 1) {
                    let detalles = [];
                    let licenciasServidorMap = {};
                    let productosPorSuscripcion = {};

                    try {
                        const ObjDetalles = JSON.parse(data.detalles);

                        const getTable = (obj, tableName) => {
                            if (!obj || typeof obj !== 'object') return [];
                            return obj[tableName] || obj[tableName.toLowerCase()] || [];
                        };

                        // Patrón estándar del SP: siempre será un objeto con tablas
                        detalles = getTable(ObjDetalles, 'Table2');

                        // Nuevo formato simple: Table3 = detalles de suscripcion
                        const table3Detalles = getTable(ObjDetalles, 'Table3');
                        if (Array.isArray(table3Detalles)) {
                            table3Detalles.forEach((detalle) => {
                                const key = detalle.idSuscripcion?.toString();
                                if (!key) return;

                                if (!productosPorSuscripcion[key]) {
                                    productosPorSuscripcion[key] = [];
                                }

                                productosPorSuscripcion[key].push(detalle);
                            });
                        }

                        // Nuevo formato simple: Table4 = detalle licencias
                        const table4Licencias = getTable(ObjDetalles, 'Table4');
                        if (Array.isArray(table4Licencias)) {
                            table4Licencias.forEach((licDetalle) => {
                                const key = licDetalle.idSuscripcion?.toString();
                                if (!key) return;

                                if (!licenciasServidorMap[key]) {
                                    licenciasServidorMap[key] = [];
                                }

                                licenciasServidorMap[key].push(licDetalle);
                            });
                        }
                    } catch (parseError) {
                        console.error('Error parsing detalles:', parseError);
                        detalles = [];
                        productosPorSuscripcion = {};
                    }

                    setSuscripciones(detalles);
                    setLicenciasServidor(licenciasServidorMap);
                    setProductosOrdenPrincipal(productosPorSuscripcion);

                    // Inicializar estados para cada suscripción
                    const initialStates = {};
                    detalles.forEach(suscripcion => {
                        const id = suscripcion.idSuscripcion.toString();
                        initialStates[id] = [];
                    });

                    setOrdenesSuscripcion(initialStates);

                    // Inicializar paginación y hasMore para cada suscripción
                    const initialPagination = {};
                    const initialHasMore = {};
                    const initialTotal = {};
                    detalles.forEach(suscripcion => {
                        const id = suscripcion.idSuscripcion.toString();
                        initialPagination[id] = 1;
                        initialHasMore[id] = true;
                        initialTotal[id] = 0;
                    });

                    setPaginaOrdenes(initialPagination);
                    setHasMoreOrdenes(initialHasMore);
                    setTotalOrdenes(initialTotal);

                } else {
                    showErrorToast(data.vMessage);
                }

            } else {
                console.error('❌ Response not OK:', response.status, response.statusText);
                showErrorToast(`Error ${response.status}: ${response.statusText}`);

                if (response.status === 401) {
                    setToken(null);
                    location.href = "";
                }
            }
        } catch (error) {
            console.error('❌ Error completo:', error);
            showErrorToast('Hubo un problema con la petici&oacute;n: ' + error.message);
        }

        setCargando(false);
    };

    /**
     * Obtiene más órdenes para el scroll infinito
     */
    const fetchMoreOrdenes = async (idSuscripcion) => {
        try {
            const requestBody = {
                idSuscripcion: idSuscripcion,
                pagina: paginaOrdenes[idSuscripcion] || 1,
                tamanioPagina: 5
            };

            const response = await fetch('/api/Suscripciones/ObtenerOrdenesSuscripcion', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify(requestBody)
            });

            if (response.ok) {
                const data = await response.json();

                if (data.iResponseType === 1) {
                    const parsed = JSON.parse(data.detalles);
                    const nuevasOrdenes = parsed.table2 || [];
                    const total = parsed.table3?.[0]?.totalOrdenes || 0;

                    setTotalOrdenes(prev => ({ ...prev, [idSuscripcion]: total }));

                    if (nuevasOrdenes && nuevasOrdenes.length > 0) {
                        if (paginaOrdenes[idSuscripcion] === 1) {
                            setOrdenesSuscripcion(prev => ({
                                ...prev,
                                [idSuscripcion]: nuevasOrdenes
                            }));
                        } else {
                            setOrdenesSuscripcion(prev => ({
                                ...prev,
                                [idSuscripcion]: [...(prev[idSuscripcion] || []), ...nuevasOrdenes]
                            }));
                        }

                        setPaginaOrdenes(prev => ({
                            ...prev,
                            [idSuscripcion]: (prev[idSuscripcion] || 1) + 1
                        }));

                        if (nuevasOrdenes.length < 5) {
                            setHasMoreOrdenes(prev => ({ ...prev, [idSuscripcion]: false }));
                        }
                    } else {
                        setHasMoreOrdenes(prev => ({ ...prev, [idSuscripcion]: false }));
                    }
                } else {
                    showErrorToast(data.vMessage);
                    setHasMoreOrdenes(prev => ({ ...prev, [idSuscripcion]: false }));
                }
            } else {
                showErrorToast(response.status + ' ' + response.statusText);
                if (response.status === 401) {
                    setToken(null);
                    location.href = '';
                }
                setHasMoreOrdenes(prev => ({ ...prev, [idSuscripcion]: false }));
            }
        } catch (error) {
            showErrorToast('Error al obtener órdenes: ' + error.message);
            setHasMoreOrdenes(prev => ({ ...prev, [idSuscripcion]: false }));
        }
    };

    /**
     * Reinicia y carga las órdenes de una suscripción desde cero
     */
    const cargarOrdenesIniciales = async (idSuscripcion) => {
        // Resetear estados para esta suscripción
        setOrdenesSuscripcion(prev => ({ ...prev, [idSuscripcion]: [] }));
        setPaginaOrdenes(prev => ({ ...prev, [idSuscripcion]: 1 }));
        setHasMoreOrdenes(prev => ({ ...prev, [idSuscripcion]: true }));

        // Cargar primera página
        await fetchMoreOrdenes(idSuscripcion);
    };

    /**
     * Renderiza el badge del estatus de la suscripción
     */
    const renderBadgeEstatus = (suscripcionOrStatus) => {
        // Puede recibir el objeto suscripción o solo el iStatus
        let iStatus = typeof suscripcionOrStatus === 'object' ? suscripcionOrStatus.iStatus : suscripcionOrStatus;

        const estatusConfig = {
            0: { bg: 'warning', text: 'PENDIENTE' },
            1: { bg: 'success', text: 'ACTIVA' },
            2: { bg: 'danger', text: 'CANCELADA' },
            3: { bg: 'secondary', text: 'SUSPENDIDA' }
        };

        const config = estatusConfig[iStatus] || { bg: 'secondary', text: 'DESCONOCIDO' };

        // Si es cancelada y recibimos el objeto suscripción, calcular días restantes
        if (iStatus === 2 && typeof suscripcionOrStatus === 'object') {
            const sus = suscripcionOrStatus;
            // ✅ USAR dFechaCancelacion (fecha establecida al cancelar) 
            // Si no existe, fallback a dFinLicenciaUso (fecha fin de licencia pagada)
            const fechaFinalStr = sus.dFechaCancelacion || sus.dFinLicenciaUso || sus.dFechaFinalizacion || null;
            if (fechaFinalStr) {
                const fechaFinal = new Date(fechaFinalStr);
                const ahora = new Date();
                // normalizar horas
                fechaFinal.setHours(0,0,0,0);
                ahora.setHours(0,0,0,0);
                const diffMs = fechaFinal - ahora;
                const dias = Math.ceil(diffMs / (1000 * 60 * 60 * 24));

                if (dias > 0) {
                    return (
                        <Badge bg={config.bg} className="me-2">
                            {`Cancelación en ${dias} día${dias !== 1 ? 's' : ''}`}
                        </Badge>
                    );
                }
                // si ya venció, mostrar simplemente "CANCELADA"
            }
        }

        return (
            <Badge bg={config.bg} className="me-2">
                {config.text}
            </Badge>
        );
    };

    /**
     * Renderiza el badge del estatus de una orden
     */
    const renderBadgeEstatusOrden = (estatus) => {
        const estatusConfig = {
            'Pagada': { bg: 'success', text: 'PAGADA' },
            'Pendiente': { bg: 'warning', text: 'PENDIENTE' },
            'Cancelada': { bg: 'danger', text: 'CANCELADA' },
            'Procesando': { bg: 'info', text: 'PROCESANDO' }
        };

        const config = estatusConfig[estatus] || { bg: 'secondary', text: estatus };

        return (
            <Badge bg={config.bg} size="sm">
                {config.text}
            </Badge>
        );
    };

    /**
     * Renderiza la información de periodicidad
     */
    const renderPeriodicidad = (tipoSuscripcion) => {
        const key = (tipoSuscripcion || '').toString().toLowerCase();
        const periodicidadConfig = {
            'mensual': { icon: 'calendar-alt', color: 'text-primary', label: 'Mensual' },
            'trimestral': { icon: 'calendar-alt', color: 'text-info', label: 'Trimestral' },
            'semestral': { icon: 'calendar-alt', color: 'text-warning', label: 'Semestral' },
            'anual': { icon: 'calendar-alt', color: 'text-success', label: 'Anual' }
        };

        const config = periodicidadConfig[key] || { color: 'text-muted', label: tipoSuscripcion };

        return (
            <span className={config.color}>
                <FontAwesomeIcon icon={config.icon} className="me-1" />
                {config.label || tipoSuscripcion}
            </span>
        );
    };

    const obtenerLicenciasDetalle = (idSuscripcion, idSuscripcionDetalle) => {
        const key = idSuscripcion?.toString();
        const licencias = licenciasServidor[key] || [];
        return licencias.filter((lic) => lic.idSuscripcionDetalle === idSuscripcionDetalle);
    };

    /**
     * Construye y copia el link de pago manual para suscripciones pendientes.
     */
    const copiarLinkPagoSuscripcionPendiente = async (suscripcion) => {
        const uuidEmpresa = suscripcion?.vUUIDEmpresa;
        const uuidLicencia = suscripcion?.vUUIDLicencia;
        const uuidSuscripcion = suscripcion?.vUUIDSuscripcion;
        const idSuscripcion = suscripcion?.idSuscripcion;
        const key = suscripcion?.idSuscripcion?.toString();
        const detalleLicencia = key ? (licenciasServidor[key] || [])[0] : null;
        const idProductoPrecio = Number(
            suscripcion?.idProductoPrecio ?? detalleLicencia?.idProductoPrecio ?? 0
        );

        if (!uuidEmpresa || !uuidLicencia || !uuidSuscripcion) {
            showErrorToast('No se pudo generar el link: faltan UUIDs de suscripción/licencia.');
            return;
        }

        if (!idProductoPrecio || Number.isNaN(idProductoPrecio)) {
            showErrorToast('No se pudo generar el link: falta idProductoPrecio.');
            return;
        }

        const payload = {
            idProductoPrecio,
            idClienteAkasia: Number(idCliente),
            esSuscripcion: 1,
            uuidEmpresa,
            uuidLicencia,
            uuidSuscripcion
        };

        const encoded = btoa(unescape(encodeURIComponent(JSON.stringify(payload))));
        const paymentUrl = `${urlBasePagos}vSub=${encodeURIComponent(encoded)}`;

        try {
            let copiadoExitoso = false;

            try {
                await navigator.clipboard.writeText(paymentUrl);
                copiadoExitoso = true;
            } catch (clipboardError) {
                const textArea = document.createElement('textarea');
                textArea.value = paymentUrl;
                textArea.style.position = 'fixed';
                textArea.style.left = '-999999px';
                textArea.style.top = '-999999px';
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();

                try {
                    document.execCommand('copy');
                    copiadoExitoso = true;
                } catch (execError) {
                    console.error('Error al copiar link de suscripción con execCommand:', execError);
                }

                document.body.removeChild(textArea);
            }

            if (copiadoExitoso) {
                if (idSuscripcion) {
                    setLinkCopiado(prev => ({ ...prev, [idSuscripcion]: true }));
                    setTimeout(() => {
                        setLinkCopiado(prev => ({ ...prev, [idSuscripcion]: false }));
                    }, 2000);
                }
                showSuccessToast('Link de pago de suscripción copiado.');
            } else {
                showErrorToast('No se pudo copiar el link de suscripción.');
            }
        } catch (error) {
            console.error('Error al copiar link de suscripción:', error);
            showErrorToast('No se pudo copiar el link de suscripción.');
        }
    };

    /**
     * Copia el link de pago al portapapeles usando el endpoint GetPaymentLink
     */
    const copiarLinkPago = async (vUUIDLinkPago, idSuscripcion) => {
        try {
            const response = await fetch(`/api/orden/GetPaymentLink?vUUIDLinkPago=${vUUIDLinkPago}`, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            }).catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch: ' + error);
                console.log('Hubo un problema con la peticion Fetch: ' + error.message);
                return null;
            });

            if (response && response.ok) {
                const data = await response.json();
                console.log('Data: ' + data.vMessage);

                if (data.iResponseType === 1) {
                    let copiadoExitoso = false;

                    // Método alternativo para iOS
                    try {
                        await navigator.clipboard.writeText(data.vMessage);
                        copiadoExitoso = true;
                    } catch (clipboardError) {
                        // Fallback para iOS usando un elemento temporal
                        const textArea = document.createElement('textarea');
                        textArea.value = data.vMessage;
                        textArea.style.position = 'fixed';
                        textArea.style.left = '-999999px';
                        textArea.style.top = '-999999px';
                        document.body.appendChild(textArea);
                        textArea.focus();
                        textArea.select();

                        try {
                            document.execCommand('copy');
                            copiadoExitoso = true;
                        } catch (execError) {
                            console.error('Error al copiar con execCommand:', execError);
                        }

                        document.body.removeChild(textArea);
                    }

                    if (copiadoExitoso) {
                        setLinkCopiado(prev => ({ ...prev, [idSuscripcion]: true }));

                        setTimeout(() => {
                            setLinkCopiado(prev => ({ ...prev, [idSuscripcion]: false }));
                        }, 2000);
                    } else {
                        showErrorToast('No se pudo copiar el enlace. Por favor, cópialo manualmente.');
                    }
                } else {
                    showErrorToast(data.vMessage);
                }
            } else {
                showErrorToast(response?.status + ' ' + response?.statusText);
                console.log(response);

                if (response?.status === 401) {
                    setToken(null);
                    location.href = "";
                }
            }
        } catch (error) {
            console.error('Error al copiar al portapapeles:', error);
            showErrorToast('Error al obtener el enlace de pago');
        }
    };

    /**
     * Copia el Stripe Subscription ID de la suscripción.
     */
    const copiarStripeSubscriptionId = async (idSuscripcion, vStripeSubscriptionId) => {
        if (!vStripeSubscriptionId) {
            showErrorToast('Esta suscripción no tiene Stripe Subscription ID.');
            return;
        }

        try {
            let copiadoExitoso = false;

            try {
                await navigator.clipboard.writeText(vStripeSubscriptionId);
                copiadoExitoso = true;
            } catch (clipboardError) {
                const textArea = document.createElement('textarea');
                textArea.value = vStripeSubscriptionId;
                textArea.style.position = 'fixed';
                textArea.style.left = '-999999px';
                textArea.style.top = '-999999px';
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();

                try {
                    document.execCommand('copy');
                    copiadoExitoso = true;
                } catch (execError) {
                    console.error('Error al copiar Stripe Subscription ID con execCommand:', execError);
                }

                document.body.removeChild(textArea);
            }

            if (copiadoExitoso) {
                setStripeIdCopiado(prev => ({ ...prev, [idSuscripcion]: true }));
                setTimeout(() => {
                    setStripeIdCopiado(prev => ({ ...prev, [idSuscripcion]: false }));
                }, 2000);
            } else {
                showErrorToast('No se pudo copiar el Stripe Subscription ID.');
            }
        } catch (error) {
            console.error('Error al copiar Stripe Subscription ID:', error);
            showErrorToast('No se pudo copiar el Stripe Subscription ID.');
        }
    };

    const guardarStripeSubscriptionId = async (idSuscripcion) => {
        const valor = (nuevoStripeId[idSuscripcion] || '').trim();
        if (!valor) return;

        setGuardandoStripeId(prev => ({ ...prev, [idSuscripcion]: true }));
        try {
            const response = await fetch('/api/Suscripciones/ActualizarStripeSubscriptionId', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify({ idSuscripcion, vStripeSubscriptionId: valor })
            });

            if (response.ok) {
                const data = await response.json();
                if (data.iResponseType === 1) {
                    showSuccessToast(data.vMessage || 'Stripe ID actualizado.');
                    setNuevoStripeId(prev => ({ ...prev, [idSuscripcion]: '' }));
                    setEditandoStripeId(prev => ({ ...prev, [idSuscripcion]: false }));
                    await obtenerSuscripcionesCliente();
                } else {
                    showErrorToast(data.vMessage);
                }
            } else {
                if (response.status === 401) { setToken(null); location.href = ''; }
                showErrorToast(`Error ${response.status}: ${response.statusText}`);
            }
        } catch (err) {
            showErrorToast('Error al actualizar: ' + err.message);
        } finally {
            setGuardandoStripeId(prev => ({ ...prev, [idSuscripcion]: false }));
        }
    };

    /**
     * Maneja la expansión de un accordion item
     */
    const handleAccordionExpand = (idSuscripcion) => {
        // Si no hay órdenes cargadas para esta suscripción, cargar iniciales
        if (!ordenesSuscripcion[idSuscripcion] || ordenesSuscripcion[idSuscripcion].length === 0) {
            cargarOrdenesIniciales(idSuscripcion);
        }

        // Si no hay productos cargados para esta suscripción, cargarlos
        if (!productosOrdenPrincipal[idSuscripcion]) {
            obtenerProductosOrdenPrincipal(idSuscripcion);
        }
    };

    /**
     * Obtiene los productos de la orden principal de una suscripción
     */
    const obtenerProductosOrdenPrincipal = async (idSuscripcion) => {
        try {
            setCargandoProductos(prev => ({ ...prev, [idSuscripcion]: true }));

            const response = await fetch(`/api/Suscripciones/ObtenerProductosOrdenPrincipal?idSuscripcion=${idSuscripcion}`, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                const data = await response.json();

                if (data.iResponseType === 1) {
                    const parsed = JSON.parse(data.detalles);
                    const productos = parsed.table2 || [];

                    setProductosOrdenPrincipal(prev => ({
                        ...prev,
                        [idSuscripcion]: productos
                    }));
                } else {
                    showErrorToast(data.vMessage);
                    setProductosOrdenPrincipal(prev => ({
                        ...prev,
                        [idSuscripcion]: []
                    }));
                }
            } else {
                showErrorToast(`Error ${response.status}: ${response.statusText}`);
                if (response.status === 401) {
                    setToken(null);
                    location.href = '';
                }
                setProductosOrdenPrincipal(prev => ({
                    ...prev,
                    [idSuscripcion]: []
                }));
            }
        } catch (error) {
            showErrorToast('Error al obtener productos: ' + error.message);
            setProductosOrdenPrincipal(prev => ({
                ...prev,
                [idSuscripcion]: []
            }));
        } finally {
            setCargandoProductos(prev => ({ ...prev, [idSuscripcion]: false }));
        }
    };

    /**
     * Abre el modal de confirmación para cancelar suscripción
     */
    const abrirModalCancelar = (suscripcion) => {
        setSuscripcionACancelar(suscripcion);
        setShowModalCancelar(true);
    };

    /**
     * Cancela una suscripción
     * @param {boolean} bCancelInStripe - Si true, cancela también en Stripe. Si false, solo en BD.
     */
    const cancelarSuscripcion = async (bCancelInStripe = true) => {
        if (!suscripcionACancelar) return;

        try {
            setCancelandoId(suscripcionACancelar.idSuscripcion);

            const response = await fetch('/api/Suscripciones/CancelarSuscripcion', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify({
                    idSuscripcion: suscripcionACancelar.idSuscripcion,
                    motivoCancelacion: 'Cancelación solicitada desde el panel',
                    bCancelInStripe: bCancelInStripe
                })
            });

            if (response.ok) {
                const data = await response.json();
                if (data.iResponseType === 1) {
                    showSuccessToast(data.vMessage || 'Suscripción cancelada correctamente');
                    await obtenerSuscripcionesCliente(); // refrescar lista

                    // Notificar al padre para refrescar licencias/servicios contratados
                    if (onPagoManualRegistrado) {
                        try {
                            await onPagoManualRegistrado();
                        } catch (refreshError) {
                            console.error('Error al refrescar datos del padre tras cancelación:', refreshError);
                        }
                    }
                } else {
                    showErrorToast(data.vMessage || 'No fue posible cancelar la suscripción');
                }
            } else {
                if (response.status === 401) {
                    setToken(null);
                    location.href = '';
                }
                showErrorToast(`${response.status} ${response.statusText}`);
            }
        } catch (error) {
            showErrorToast('Error al cancelar la suscripción: ' + error.message);
        } finally {
            setCancelandoId(null);
            setShowModalCancelar(false);
            setSuscripcionACancelar(null);
        }
    };

    // Recuperación deshabilitada: una vez cancelada, no puede recuperarse

    /**
     * Abre el modal de confirmación para pago manual
     */
    const abrirModalPagoManual = async (suscripcion) => {
        setSuscripcionAPagar(suscripcion);

        // Obtener estado de pago completo desde el backend
        await obtenerEstadoPagoSuscripcion(suscripcion.idSuscripcion);

        // Siempre usar ModalConfirmarPagoManual (ahora con campos completos)
        setShowModalPagoManual(true);
    };

    /**
     * Obtiene el estado de pago completo de una suscripción
     * Retorna: saldo restante, suma de pagos, si todas las órdenes están pagadas
     */
    const obtenerEstadoPagoSuscripcion = async (idSuscripcion) => {
        try {
            const response = await fetch(`/api/Suscripciones/ObtenerEstadoPagoSuscripcion?idSuscripcion=${idSuscripcion}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                const estado = await response.json();
                setEstadoPagoSuscripcion({
                    dSaldoRestante: estado.dSaldoRestante,
                    dSumaPagos: estado.dSumaPagos,
                    bTodasOrdensPagadas: estado.bTodasOrdensPagadas
                });
                return estado;
            } else {
                setEstadoPagoSuscripcion({
                    dSaldoRestante: 0,
                    dSumaPagos: 0,
                    bTodasOrdensPagadas: false
                });
                return null;
            }
        } catch (error) {
            console.error('Error al obtener estado de pago:', error);
            setEstadoPagoSuscripcion({
                dSaldoRestante: 0,
                dSumaPagos: 0,
                bTodasOrdensPagadas: false
            });
            return null;
        }
    };

    /**
     * Confirma y ejecuta el pago manual de la suscripción
     * @param {Object} dataForm - Datos del formulario de pago
     */
    const confirmarPagoManual = async (dataForm) => {
        if (!suscripcionAPagar) return;

        try {
            setProcesandoPago(true);

            // Convertir archivo a base64 si existe
            let archivoBase64 = null;
            let nombreArchivo = null;
            let tipoArchivo = null;
            
            if (dataForm.vArchivo) {
                const file = dataForm.vArchivo;
                nombreArchivo = file.name;
                tipoArchivo = file.type;
                
                // Convertir a base64
                const reader = new FileReader();
                archivoBase64 = await new Promise((resolve, reject) => {
                    reader.onload = () => {
                        // Remover el prefijo "data:...;base64,"
                        const base64 = reader.result.split(',')[1];
                        resolve(base64);
                    };
                    reader.onerror = reject;
                    reader.readAsDataURL(file);
                });
            }

            console.log('🔍 Datos de pago manual:', {
                idSuscripcion: suscripcionAPagar.idSuscripcion,
                idOrden: 0,
                monto: dataForm.dImportePagado
            });

            const response = await fetch('/api/Suscripciones/RealizarPagoManualSuscripcionOtrosMetodos', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify({
                    idSuscripcion: suscripcionAPagar.idSuscripcion,
                    idOrden: 0,
                    vUUIDSuscripcion: suscripcionAPagar.vUUIDSuscripcion,
                    vStripeSubscriptionId: suscripcionAPagar.vStripeSubscriptionId,
                    vMoneda: suscripcionAPagar.vMoneda || 'MXN',
                    dTipoCambio: suscripcionAPagar.dTipoCambio || 1,
                    dImportePagado: Number.parseFloat(dataForm.dImportePagado),
                    idCatFormaPago: Number.parseInt(dataForm.idCatFormaPago),
                    dFechaPago: dataForm.dFechaPago,
                    vReferencia: dataForm.vReferencia,
                    vJsonDetallesLinkPago: JSON.stringify(dataForm.vJsonDetallesLinkPago || {}),
                    vArchivoBase64: archivoBase64,
                    vNombreArchivo: nombreArchivo,
                    vTipoArchivo: tipoArchivo
                })
            });

            if (response.ok) {
                const data = await response.json();
                if (data.iResponseType === 1) {
                    showSuccessToast(data.vMessage || 'Pago registrado correctamente');
                    
                    // Refrescar la lista de suscripciones y órdenes
                    await obtenerSuscripcionesCliente();
                    await fetchMoreOrdenes(suscripcionAPagar.idSuscripcion.toString());
                    
                    // Notificar al padre para refrescar licencias
                    if (onPagoManualRegistrado) onPagoManualRegistrado();
                    
                    // Cerrar modal
                    setShowModalPagoManual(false);
                    setSuscripcionAPagar(null);
                } else {
                    showErrorToast(data.vMessage || 'No fue posible registrar el pago');
                }
            } else {
                if (response.status === 401) {
                    setToken(null);
                    location.href = '';
                }
                showErrorToast(`Error ${response.status}: ${response.statusText}`);
            }
        } catch (error) {
            showErrorToast('Error al registrar el pago: ' + error.message);
        } finally {
            setProcesandoPago(false);
        }
    };

    useEffect(() => {
        console.log('🔍 SeccionSuscripciones mounted');
        console.log('🔍 idCliente:', idCliente);
        obtenerUrlBasePagos(); // Obtener URL base de pagos
        if (idCliente) {
            obtenerSuscripcionesCliente();
        }
    }, [idCliente, refreshKey]);

    return (
        <ErrorBoundary>
            <Card>
                <Card.Header>
                    <Row className="align-items-center">
                        <Col>
                            <h5 className="mb-0">
                                <FontAwesomeIcon icon="sync-alt" className="me-2 text-primary" />
                                Suscripciones
                            </h5>
                        </Col>
                        <Col xs="auto" className="d-flex align-items-center gap-2">
                            {suscripciones.length > 0 && (
                                <Badge bg="info" className="me-2">
                                    {suscripciones.length} suscripci&oacute;n{suscripciones.length !== 1 ? 'es' : ''}
                                </Badge>
                            )}

                        </Col>
                    </Row>
                </Card.Header>

                <Card.Body className="border-top fs--1">
                    {cargando ? (
                        <div className="p-3">
                            <Row>
                                {[1, 2].map((item) => (
                                    <Col lg={6} key={item} className="mb-3">
                                        <div className="border rounded-3 p-3">
                                            <Skeleton height={20} width="60%" className="mb-2" />
                                            <Skeleton height={16} width="40%" className="mb-2" />
                                            <Skeleton height={14} width="80%" className="mb-2" />
                                            <Skeleton height={14} width="70%" />
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        </div>
                    ) : suscripciones.length > 0 ? (
                        <Accordion
                            defaultActiveKey=""
                            onSelect={(eventKey) => {
                                if (eventKey) {
                                    const suscripcionIndex = parseInt(eventKey);
                                    const suscripcion = suscripciones[suscripcionIndex];
                                    if (suscripcion) {
                                        handleAccordionExpand(suscripcion.idSuscripcion.toString());
                                    }
                                }
                            }}
                        >
                            {suscripciones.map((suscripcion, index) => (
                                <Accordion.Item eventKey={index.toString()} key={index} className="mb-2">
                                    <Accordion.Header>
                                        <div className="w-100 d-flex justify-content-between align-items-center me-3">
                                            <div className="d-flex align-items-center flex-wrap">
                                                <Badge bg="primary" className="me-2">
                                                    #{suscripcion.idSuscripcion}
                                                </Badge>

                                                <span className="fw-bold">{suscripcion.vNombreSuscripcion}</span>
                                                <span className="ms-2">{renderBadgeEstatus(suscripcion)}</span>
                                            </div>
                                            <div className="text-end">
                                                <span className="fw-bold text-success">
                                                    ${parseFloat((suscripcion.dPrecio ?? suscripcion.dTotal) || 0).toLocaleString('es-MX', {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    })} {suscripcion.vMoneda || 'MXN'}
                                                </span>
                                                    <div className="small text-muted">
                                                    {renderPeriodicidad(suscripcion.vTipoRenovacion)}
                                                </div>
                                            </div>
                                        </div>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <Row>
                                            {/* Columna izquierda: Información simplificada */}
                                            <Col lg={7} className="mb-3">
                                                <div className="d-flex justify-content-between align-items-center mb-3 gap-2">
                                                    <h6 className="fw-bold mb-0">
                                                        <FontAwesomeIcon icon="info-circle" className="me-2 text-info" />
                                                        Informaci&oacute;n de la Suscripci&oacute;n
                                                    </h6>

                                                    {suscripcion.iStatus == 0 && (
                                                        <Button
                                                            variant="outline-primary"
                                                            size="sm"
                                                            onClick={() => copiarLinkPagoSuscripcionPendiente(suscripcion)}
                                                        >
                                                            <FontAwesomeIcon icon="link" className="me-2" />
                                                            {linkCopiado[suscripcion.idSuscripcion] ? '¡Copiado!' : 'Copiar link de pago'}
                                                        </Button>
                                                    )}
                                                </div>
                                                      {suscripcion.vNombreUsuarioCreador && (
                                                    <div className="small text-muted mt-2">
                                                        <FontAwesomeIcon icon="user" className="me-1" />
                                                        Creada por: {suscripcion.vNombreUsuarioCreador}
                                                    </div>
                                                )}
                                                {suscripcion.iStatus == 2 && suscripcion.vUpdatedUser && (
                                                    <div className="small text-danger mt-1">
                                                        <FontAwesomeIcon icon="user-slash" className="me-1" />
                                                        Cancelada por: <strong>{suscripcion.vCanceladoUser || suscripcion.vUpdatedUser}</strong>
                                                        {suscripcion.dFechaCancelacion && (
                                                            <span className="ms-2 text-muted">
                                                                · efectiva {formatearFecha(suscripcion.dFechaCancelacion)}
                                                            </span>
                                                        )}
                                                    </div>
                                                )}

                                                {/* Stripe Subscription ID */}
                                                <div className="d-flex align-items-center flex-wrap gap-2 mb-2">
                                                    <span className="text-muted">Stripe ID:</span>

                                                    {suscripcion.vStripeSubscriptionId && !editandoStripeId[suscripcion.idSuscripcion] && (
                                                        <>
                                                            <Badge bg="light" className="text-wrap text-dark border">
                                                                {suscripcion.vStripeSubscriptionId}
                                                            </Badge>
                                                            <Button
                                                                size="sm"
                                                                variant="outline-secondary"
                                                                className="d-flex align-items-center"
                                                                onClick={() => copiarStripeSubscriptionId(
                                                                    suscripcion.idSuscripcion,
                                                                    suscripcion.vStripeSubscriptionId
                                                                )}
                                                            >
                                                                <FontAwesomeIcon icon="copy" className="me-1" />
                                                                {stripeIdCopiado[suscripcion.idSuscripcion] ? '¡Copiado!' : 'Copiar ID'}
                                                            </Button>
                                                            {(idCatTipoUsuario === 1 || idCatTipoUsuario === '1') && (
                                                                <Button
                                                                    size="sm"
                                                                    variant="outline-warning"
                                                                    className="d-flex align-items-center"
                                                                    onClick={() => setEditandoStripeId(prev => ({ ...prev, [suscripcion.idSuscripcion]: true }))}
                                                                >
                                                                    <FontAwesomeIcon icon="edit" className="me-1" />
                                                                    Editar
                                                                </Button>
                                                            )}
                                                        </>
                                                    )}

                                                    {(idCatTipoUsuario === 1 || idCatTipoUsuario === '1') &&
                                                     (!suscripcion.vStripeSubscriptionId || editandoStripeId[suscripcion.idSuscripcion]) && (
                                                        <>
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                style={{ maxWidth: '260px' }}
                                                                placeholder="sub_xxxxxxxxxxxx"
                                                                value={nuevoStripeId[suscripcion.idSuscripcion] || ''}
                                                                onChange={e => setNuevoStripeId(prev => ({ ...prev, [suscripcion.idSuscripcion]: e.target.value }))}
                                                                disabled={guardandoStripeId[suscripcion.idSuscripcion]}
                                                            />
                                                            <Button
                                                                size="sm"
                                                                variant="outline-success"
                                                                disabled={!nuevoStripeId[suscripcion.idSuscripcion]?.trim() || guardandoStripeId[suscripcion.idSuscripcion]}
                                                                onClick={() => guardarStripeSubscriptionId(suscripcion.idSuscripcion)}
                                                            >
                                                                {guardandoStripeId[suscripcion.idSuscripcion]
                                                                    ? <><span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true" />Guardando...</>
                                                                    : <><FontAwesomeIcon icon="save" className="me-1" />Guardar</>
                                                                }
                                                            </Button>
                                                            {editandoStripeId[suscripcion.idSuscripcion] && (
                                                                <Button
                                                                    size="sm"
                                                                    variant="outline-secondary"
                                                                    onClick={() => {
                                                                        setEditandoStripeId(prev => ({ ...prev, [suscripcion.idSuscripcion]: false }));
                                                                        setNuevoStripeId(prev => ({ ...prev, [suscripcion.idSuscripcion]: '' }));
                                                                    }}
                                                                >
                                                                    Cancelar
                                                                </Button>
                                                            )}
                                                        </>
                                                    )}
                                                </div>
                                                
                                                <div className="d-flex align-items-center gap-3 flex-wrap mb-1 border border-2 rounded p-2">                                                    
                                                    
                                                    <div className="me-0 me-md-1 me-xl-4">
                                                        <span className="text-muted">Moneda:</span>
                                                        <span className="fw-bold ms-2">{suscripcion.vMoneda || 'MXN'}</span>
                                                    </div>
                                                    
                                                    <div className="me-0 me-md-1 me-xl-4" >                                                        <span className="text-muted">Creada:</span>
                                                        <span className="ms-2">
                                                            <FontAwesomeIcon icon="calendar-alt" className="me-1 text-muted" />
                                                            {formatearFecha(suscripcion.dFechaCreacion || suscripcion.dCreatedDate)}
                                                        </span>
                                                    </div>
                                                    
                                                    {(suscripcion.dProximoPago || suscripcion.iStatus == 2) && (
                                                        <div className="me-0 me-xl-4">
                                                            <span className="text-muted">Próximo pago:</span>
                                                            <span className="ms-2">
                                                                {suscripcion.dProximoPago
                                                                    ? <><FontAwesomeIcon icon="calendar-check" className="me-1 text-muted" />{formatearFecha(suscripcion.dProximoPago)}</>
                                                                    : <span className="text-muted fst-italic">No hay próxima fecha pago</span>
                                                                }
                                                            </span>
                                                        </div>
                                                    )}
                                                    
                                                </div>
                                                
                                            </Col>
                                            
                                            {/* Columna derecha: Órdenes Relacionadas */}
                                            <Col lg={5} className="mb-3">
                                                <div className="d-flex justify-content-between align-items-center mb-2">
                                                    <h6 className="fw-bold mb-0">
                                                        <FontAwesomeIcon icon="shopping-cart" className="me-2 text-success" />
                                                        &Oacute;rdenes Relacionadas
                                                    </h6>
                                                    {totalOrdenes[suscripcion.idSuscripcion] > 0 && (
                                                        <Badge bg="primary">
                                                            {totalOrdenes[suscripcion.idSuscripcion]}
                                                        </Badge>
                                                    )}
                                                </div>

                                                <div
                                                    className="border rounded-3 p-2 bg-light"
                                                    style={{ maxHeight: '200px', overflowY: 'auto' }}
                                                    id={`scrollableTargetOrdenes-${suscripcion.idSuscripcion}`}
                                                >
                                                    {ordenesSuscripcion[suscripcion.idSuscripcion] && ordenesSuscripcion[suscripcion.idSuscripcion].length > 0 ? (
                                                        <InfiniteScroll
                                                            dataLength={ordenesSuscripcion[suscripcion.idSuscripcion].length}
                                                            next={() => fetchMoreOrdenes(suscripcion.idSuscripcion.toString())}
                                                            hasMore={hasMoreOrdenes[suscripcion.idSuscripcion] || false}
                                                            loader={
                                                                <div className="d-flex justify-content-center align-items-center py-2">
                                                                    <Spinner animation="border" size="sm" variant="primary" />
                                                                </div>
                                                            }
                                                            scrollableTarget={`scrollableTargetOrdenes-${suscripcion.idSuscripcion}`}
                                                            scrollThreshold={0.70}
                                                            endMessage={
                                                                ordenesSuscripcion[suscripcion.idSuscripcion].length > 2 && (
                                                                    <div className="text-center py-2">
                                                                        <small className="text-muted">Sin m&aacute;s &oacute;rdenes</small>
                                                                    </div>
                                                                )
                                                            }
                                                        >
                                                            {ordenesSuscripcion[suscripcion.idSuscripcion].map((orden, ordenIndex) => (
                                                                <div key={ordenIndex} className="mb-2">
                                                                    <Card className="border shadow-sm">
                                                                        <Card.Body className="p-2">
                                                                            <div className="d-flex justify-content-between align-items-start">
                                                                                <div className="flex-grow-1">
                                                                                    <div className="d-flex align-items-center mb-1">
                                                                                        <Link to={`/ordenes/detalle/${orden.idOrden}`} className="fw-semibold text-decoration-none">
                                                                                            <FontAwesomeIcon icon="shopping-cart" className="me-1 text-primary" />
                                                                                            Orden #{orden.idOrden}
                                                                                        </Link>
                                                                                        {orden.bEsOrdenPrimaria === 1 && (
                                                                                            <Badge bg="primary" className="ms-2">INICIAL</Badge>
                                                                                        )}
                                                                                        <span className="ms-2">{renderBadgeEstatusOrden(orden.vEstatus)}</span>
                                                                                    </div>
                                                                                    <div className="small text-muted">
                                                                                        <FontAwesomeIcon icon="calendar-alt" className="me-1" />
                                                                                        {formatearFecha(orden.dFechaCreacion)}
                                                                                    </div>
                                                                                    {orden.vDescripcion && (
                                                                                        <div className="small text-muted mt-1">{orden.vDescripcion}</div>
                                                                                    )}
                                                                                </div>
                                                                                <div className="text-end ms-2">
                                                                                    <div className="fw-bold text-success">
                                                                                        ${parseFloat(orden.dTotal || 0).toFixed(2)} {orden.vMoneda || 'USD'}
                                                                                    </div>
                                                                                    {orden.vUUIDLinkPago && orden.iStatusLink === 0 && (
                                                                                        <Button
                                                                                            size="sm"
                                                                                            variant="link"
                                                                                            className="p-0 text-decoration-none"
                                                                                            onClick={() => copiarLinkPago(orden.vUUIDLinkPago, suscripcion.idSuscripcion)}
                                                                                        >
                                                                                            <FontAwesomeIcon icon="copy" className="me-1" />
                                                                                            {linkCopiado[suscripcion.idSuscripcion] ? "¡Copiado!" : "Copiar link"}
                                                                                        </Button>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </Card.Body>
                                                                    </Card>
                                                                </div>
                                                            ))}
                                                        </InfiniteScroll>
                                                    ) : (
                                                        <Alert variant="light" className="text-center py-3 mb-0">
                                                            <FontAwesomeIcon icon="shopping-cart" className="me-1 text-muted" />
                                                            <small className="text-muted">Sin &oacute;rdenes</small>
                                                        </Alert>
                                                    )}
                                                </div>
                                            </Col>
                                        </Row>
                                        
                                        {/* Tabla de Productos (full width debajo) */}
                                        <Row className="mt-3">
                                            <Col xs={12}>
                                                <h6 className="fw-bold mb-2">
                                                    <FontAwesomeIcon icon="box" className="me-2 text-primary" />
                                                    Productos de la Suscripción
                                                </h6>
                                                    {cargandoProductos[suscripcion.idSuscripcion] ? (
                                                        <div className="d-flex justify-content-center align-items-center py-3">
                                                            <Spinner animation="border" size="sm" variant="primary" className="me-2" />
                                                            <small className="text-muted">Cargando productos...</small>
                                                        </div>
                                                    ) : productosOrdenPrincipal[suscripcion.idSuscripcion] && productosOrdenPrincipal[suscripcion.idSuscripcion].length > 0 ? (
                                                        <div className="table-responsive">
                                                            <Table size="sm" bordered hover className="mb-0">
                                                                <thead className="bg-light">
                                                                    <tr>
                                                                        <th className="border-200">Cód. Barras</th>
                                                                        <th className="border-200">Nombre Producto</th>
                                                                        <th className="border-200 text-center">Cantidad</th>
                                                                        <th className="border-200 text-end">Prec. Unit.</th>
                                                                        <th className="border-200 text-end">Importe</th>
                                                                        <th className="border-200 text-end">IVA</th>
                                                                        <th className="border-200 text-end">Total</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {productosOrdenPrincipal[suscripcion.idSuscripcion].map((producto, idx) => {
                                                                        const licenciasDeProducto = obtenerLicenciasDetalle(
                                                                            suscripcion.idSuscripcion,
                                                                            producto.idSuscripcionDetalle
                                                                        );

                                                                        return (
                                                                        <tr key={idx}>
                                                                            <td className="align-middle">
                                                                                <small className="text-nowrap">{producto.vCodigoBarras}</small>
                                                                            </td>
                                                                            <td className="align-middle">
                                                                                <small>{producto.vNombreProducto}</small>
                                                                                {licenciasDeProducto.length > 0 && (
                                                                                    <div className="mt-1">
                                                                                        {licenciasDeProducto.map((lic, licIdx) => (
                                                                                            <Badge
                                                                                                key={licIdx}
                                                                                                bg="secondary"
                                                                                                className="me-1 mb-1"
                                                                                            >
                                                                                                Lic #{lic.idLicencia}
                                                                                            </Badge>
                                                                                        ))}
                                                                                    </div>
                                                                                )}
                                                                            </td>
                                                                            <td className="align-middle text-center">
                                                                                <small>{producto.dCantidad}</small>
                                                                            </td>
                                                                            <td className="align-middle text-end">
                                                                                <small>
                                                                                    ${parseFloat(producto.dPrecioUnitario).toFixed(2)}
                                                                                </small>
                                                                            </td>
                                                                            <td className="align-middle text-end">
                                                                                <small>
                                                                                    ${parseFloat(producto.dImporte).toFixed(2)}
                                                                                </small>
                                                                            </td>
                                                                            <td className="align-middle text-end">
                                                                                <small>
                                                                                    ${parseFloat(producto.dIVA).toFixed(2)}
                                                                                </small>
                                                                            </td>
                                                                            <td className="align-middle text-end">
                                                                                <small className="fw-bold text-success">
                                                                                    ${parseFloat(producto.dTotal).toFixed(2)}
                                                                                </small>
                                                                            </td>
                                                                        </tr>
                                                                        );
                                                                    })}
                                                                </tbody>
                                                                <tfoot className="bg-light">
                                                                    <tr>
                                                                        <td colSpan="6" className="text-end fw-bold">
                                                                            <small>Total:</small>
                                                                        </td>
                                                                        <td className="text-end">
                                                                            <small className="fw-bold text-success">
                                                                                ${productosOrdenPrincipal[suscripcion.idSuscripcion]
                                                                                    .reduce((sum, p) => sum + parseFloat(p.dTotal), 0)
                                                                                    .toFixed(2)}
                                                                            </small>
                                                                        </td>
                                                                    </tr>
                                                                </tfoot>
                                                            </Table>
                                                        </div>
                                                    ) : null}

                                                    {/*
                                                    {licenciasServidor[suscripcion.idSuscripcion]?.length > 0 && (
                                                        <div className="mt-3 border rounded-3 p-2 bg-light-subtle">
                                                            <div className="fw-bold small mb-2">
                                                                <FontAwesomeIcon icon="link" className="me-1 text-secondary" />
                                                                Relaci&oacute;n Detalle - Licencia
                                                            </div>
                                                            <div className="table-responsive">
                                                                <Table size="sm" bordered className="mb-0">
                                                                    <thead className="bg-light">
                                                                        <tr>
                                                                            <th>Detalle</th>
                                                                            <th>Licencia</th>
                                                                            <th>Producto</th>
                                                                            <th>Renovaci&oacute;n</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {licenciasServidor[suscripcion.idSuscripcion].map((lic, idx) => (
                                                                            <tr key={idx}>
                                                                                <td>
                                                                                    <small>#{lic.idSuscripcionDetalle}</small>
                                                                                </td>
                                                                                <td>
                                                                                    <small className="fw-bold">#{lic.idLicencia}</small>
                                                                                </td>
                                                                                <td>
                                                                                    <small>{lic.idProducto}</small>
                                                                                </td>
                                                                                <td>
                                                                                    <small>{lic.idProductoRenovaciones}</small>
                                                                                </td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </Table>
                                                            </div>
                                                        </div>
                                                    )}
                                                    */}

                                                    {(!productosOrdenPrincipal[suscripcion.idSuscripcion] || productosOrdenPrincipal[suscripcion.idSuscripcion].length === 0) &&
                                                     (!licenciasServidor[suscripcion.idSuscripcion] || licenciasServidor[suscripcion.idSuscripcion].length === 0) && (
                                                        <Alert variant="light" className="text-center py-3 mb-0">
                                                            <FontAwesomeIcon icon="box-open" className="me-1 text-muted" />
                                                            <small className="text-muted">No hay productos</small>
                                                        </Alert>
                                                    )}
                                            </Col>
                                        </Row>
                                        
                                        {/* Botones de acción - Footer */}
                                        {suscripcion.iStatus !== 2 && (
                                            <Row className="mt-4 pt-3 border-top bg-light mx-0">
                                                <Col>
                                                    <div className="d-flex flex-wrap gap-2 justify-content-end pb-2">
                                                        {/* Solo administradores pueden cancelar suscripciones */}
                                                        {(idCatTipoUsuario === 1 || idCatTipoUsuario === '1') && (
                                                            <Button
                                                                variant="danger"
                                                                className="d-flex align-items-center flex-fill flex-sm-grow-0"
                                                                onClick={() => abrirModalCancelar(suscripcion)}
                                                                disabled={cancelandoId === suscripcion.idSuscripcion || suscripcion.iStatus === 2}
                                                            >
                                                                {cancelandoId === suscripcion.idSuscripcion ? (
                                                                    <Spinner animation="border" size="sm" className="me-2" />
                                                                ) : (
                                                                    <FontAwesomeIcon icon="ban" className="me-2" />
                                                                )}
                                                                {cancelandoId === suscripcion.idSuscripcion ? 'Cancelando...' : 'Cancelar Suscripción'}
                                                            </Button>
                                                        )}

                                                        {/* Botón Agregar Producto */}
                                                        <Button
                                                            variant="outline-primary"
                                                            className="d-flex align-items-center flex-fill flex-sm-grow-0"
                                                            disabled={suscripcion.iStatus === 0}
                                                            title={suscripcion.iStatus === 0 ? 'No se puede agregar productos a una suscripción pendiente de pago' : undefined}
                                                            onClick={() => {
                                                                const licencias = licenciasServidor[suscripcion.idSuscripcion];
                                                                const idLicencia = licencias?.[0]?.idLicencia ?? null;
                                                                setSuscripcionParaAgregarProducto({
                                                                    ...suscripcion,
                                                                    idLicencia
                                                                });
                                                                setShowModalAgregarProducto(true);
                                                            }}
                                                        >
                                                            <FontAwesomeIcon icon="plus" className="me-2" />
                                                            Agregar Producto
                                                        </Button>

                                                        {/* Botón de Pago (forma de pago 99 o automáticas) */}
                                                        <Button
                                                            variant="success"
                                                            className="d-flex align-items-center flex-fill flex-sm-grow-0"
                                                            onClick={() => abrirModalPagoManual(suscripcion)}
                                                            disabled={procesandoPago}
                                                        >
                                                            <FontAwesomeIcon icon="money-bill-wave" className="me-2" />
                                                            Realizar Pago
                                                        </Button>
                                                    </div>
                                                </Col>
                                            </Row>
                                        )}
                                    </Accordion.Body>
                                </Accordion.Item>
                            ))}
                        </Accordion>
                    ) : (
                        <Alert variant="light" className="text-center py-4">
                            <FontAwesomeIcon icon="sync-alt" size="3x" className="text-muted mb-3" />
                            <h6 className="text-muted">No hay suscripciones registradas</h6>
                            <p className="text-muted mb-0">
                                Este cliente no tiene suscripciones activas o registradas en el sistema.
                            </p>
                        </Alert>
                    )}
                </Card.Body>

                {/* Modal Cancelar Suscripción */}
                <ModalSeguroCancelarSuscripcion
                    show={showModalCancelar}
                    onClose={() => {
                        setShowModalCancelar(false);
                        setSuscripcionACancelar(null);
                    }}
                    onConfirm={cancelarSuscripcion}
                    processing={cancelandoId !== null}
                    suscripcionInfo={suscripcionACancelar}
                    isAdmin={idCatTipoUsuario == 1}
                />

                {/* Modal Confirmar Pago Manual (consolidado con todos los campos) */}
                <ModalConfirmarPagoManual
                    show={showModalPagoManual}
                    onHide={() => {
                        setShowModalPagoManual(false);
                        setSuscripcionAPagar(null);
                        setEstadoPagoSuscripcion({
                            dSaldoRestante: 0,
                            dSumaPagos: 0,
                            bTodasOrdensPagadas: false
                        });
                    }}
                    suscripcion={suscripcionAPagar}
                    ordenPendiente={null}
                    procesando={procesandoPago}
                    onConfirmar={confirmarPagoManual}
                    estadoPago={estadoPagoSuscripcion}
                />

                {/* Modal Agregar Producto a Suscripción */}
                <ModalAgregarProductoSuscripcion
                    show={showModalAgregarProducto}
                    onHide={() => {
                        setShowModalAgregarProducto(false);
                        setSuscripcionParaAgregarProducto(null);
                    }}
                    suscripcion={suscripcionParaAgregarProducto}
                    onCreated={obtenerSuscripcionesCliente}
                />


            </Card>
        </ErrorBoundary>
    );
};

SeccionSuscripciones.propTypes = {
    idCliente: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    refreshKey: PropTypes.number,
    onPagoManualRegistrado: PropTypes.func
};

export default SeccionSuscripciones;